module.exports = "/img/_/_/_/assets/images/creeper/battle/common//42.jpg?915b230ad6833d2aabec87cd62b03773";